import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 진단점검하기 step1 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue } from "recoil";
import { checkTypeState } from "../../../../../recoil/assessmentState";
import { userInfoLoginState } from "../../../../../recoil/userState";
// utils
import { langId } from "../../../../../recoil/langState";
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CONST from "../../../../../utils/Const";
import { useTrans } from "../../../../../utils/langs/useTrans";
function CheckStep1() {
    const t = useTrans();
    // recoil
    const [check, setCheck] = useRecoilState(checkTypeState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const langIds = useRecoilValue(langId);
    // useState
    const [checkTypeItem, setChecktypeItem] = useState([]);
    let appPath = `?companySpgId=${check.itemInfo.spgId}`;
    // 체크리스트 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checktypes${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChecktypeItem(data.body);
            }
        }
    }, [data, langIds]);
    // 다음 step
    function NextStep(e, item) {
        setCheck(Object.assign(Object.assign({}, check), { nextStep: "step2", chekTypeInfo: {
                checkTypeId: item.checkTypeId,
                checkTypeName: item.description,
            } }));
    }
    // 이전 이력
    function PreList(e) {
        e.preventDefault();
        setCheck(Object.assign(Object.assign({}, check), { nextStep: "prelist", preStep: "step1" }));
    }
    return (_jsx(_Fragment, { children: _jsx("main", Object.assign({ className: "container" }, { children: _jsxs("section", Object.assign({ className: "content step1" }, { children: [_jsxs("div", Object.assign({ className: "top" }, { children: [_jsx("p", { children: "Step 1" }), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.점검유형선택") }))] })), _jsxs("div", Object.assign({ className: "bottom" }, { children: [_jsx("div", Object.assign({ className: "form-area" }, { children: checkTypeItem &&
                                    checkTypeItem
                                        .filter((non) => non.checkTypeId != 4)
                                        .map((check, idx) => (_jsx("button", Object.assign({ type: "button", onClick: (e) => NextStep(e, check) }, { children: _jsx("span", { children: check.description }) }), "check_" + idx.toString()))) })), _jsx("a", Object.assign({ href: "#", onClick: (e) => PreList(e) }, { children: t("라벨.이전불러오기") }))] }))] })) })) }));
}
export default CheckStep1;
